// Button looks for the sending-domain screens. New primaries use primary-700: white on the legacy primary-600 is
// 3.3:1 and fails AA, which the rest of the legacy app still does.

const FOCUS = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900'
const DISABLED = 'disabled:opacity-50 disabled:cursor-not-allowed'

export const PRIMARY_BUTTON = `inline-flex items-center gap-2 rounded-lg bg-primary-700 px-4 py-2 text-sm font-medium text-white hover:bg-primary-800 ${FOCUS} ${DISABLED}`

export const SECONDARY_BUTTON = 'inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 '
  + `hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 ${FOCUS} ${DISABLED}`

export const SMALL_SECONDARY_BUTTON = 'inline-flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 '
  + `hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 ${FOCUS} ${DISABLED}`

export const SOFT_BUTTON = 'inline-flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2 text-sm text-slate-700 hover:bg-slate-200 '
  + `dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600 ${FOCUS} ${DISABLED}`

export const GHOST_BUTTON = 'inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-700 hover:bg-slate-100 '
  + `dark:text-slate-300 dark:hover:bg-slate-800 ${FOCUS} ${DISABLED}`

export const DANGER_GHOST_BUTTON = 'inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-red-700 hover:bg-red-50 '
  + `dark:text-red-400 dark:hover:bg-red-900/20 ${FOCUS} ${DISABLED}`

export const TEXT_LINK = 'font-medium text-primary-700 underline underline-offset-2 hover:text-primary-800 dark:text-primary-400 dark:hover:text-primary-300 '
  + 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 rounded'
